export default __webpack_public_path__ + "static/media/video-Poster.4596ad14.jpg";